import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkedAlt } from 'react-icons/fa';
import emailjs from 'emailjs-com';
import {trackEvent} from '../utils/FacebookPixel'

const ContactPage = () => {
  const [sending, setSending] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    emailjs.send(
      'service_b1dhkyl', // service id
      'template_1yq9cdj', // template id
      {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        service: formData.service,
        message: formData.message
      },
      'x7sPsvCapjY7HrBwe' // public key    
    )
    .then((response) => {
      alert('Email sent successfully!');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
      setSending(false);
      trackEvent("Form Submitted");
    })
    .catch((err) => {
      alert('Failed to send email. Please try again.');
      setSending(false);
    });
  };

  return (
    <div className="min-h-screen py-16 px-8 sm:px-16 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12">

        {/* Left Side Form */}
        <div className="bg-white p-8 rounded-lg shadow-lg flex flex-col space-y-8">
          <h2 className="text-3xl font-semibold text-center text-[#13689b]">Contact Us</h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* First and Last Name */}
              <div className="flex flex-col">
                <label htmlFor="firstName" className="text-lg text-[#13689b]">First Name</label>
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#13689b]"
                  required
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="lastName" className="text-lg text-[#13689b]">Last Name</label>
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#13689b]"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Email */}
              <div className="flex flex-col">
                <label htmlFor="email" className="text-lg text-[#13689b]">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#13689b]"
                  required
                />
              </div>
              {/* Phone */}
              <div className="flex flex-col">
                <label htmlFor="phone" className="text-lg text-[#13689b]">Phone Number</label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#13689b]"
                  required
                />
              </div>
            </div>

            <div className="flex flex-col">
              <label htmlFor="service" className="text-lg text-[#13689b]">Service</label>
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#13689b]"
                required
              >
                <option value="">Select a Service</option>
                {['Marketing', 'Finance', 'IT', 'HR'].map((service) => (
                  <option key={service} value={service}>{service}</option>
                ))}
              </select>
            </div>

            <div className="flex flex-col">
              <label htmlFor="message" className="text-lg text-[#13689b]">Message</label>
              <textarea
                id="message"
                name="message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#13689b]"
                required
              />
            </div>

            <button
              type="submit"
              disabled={sending}
              className="w-full mt-6 bg-[#13689b] text-white py-3 rounded-lg shadow-md hover:bg-[white] hover:text-[#13689b] transition duration-300 disabled:bg-gray-400 border border-[#13689b]"
            >
              {sending ? 'Sending...' : 'Submit'}
            </button>
          </form>
        </div>

        {/* Right Side Contact Information */}
        <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg">
  <h3 className="text-3xl font-semibold text-center text-[#13689b] mb-6 sm:mb-8">Our Contact Info</h3>
  <div className="space-y-6">
    {/* Email Card */}
    <div className="flex flex-col sm:flex-row items-start p-6 bg-gray-100 rounded-lg shadow-md hover:shadow-xl transition-all duration-300">
      <FaEnvelope className="h-14 w-14 text-[#13689b]" />
      <div className="ml-0 sm:ml-6 text-left mt-4 sm:mt-0">
        <h4 className="text-xl font-semibold text-[#13689b]">Email</h4>
        <p className="text-gray-600 text-sm">noureen@whymesolutions.com</p>
        <p className="text-gray-600 text-sm">info@whymesolutions.com</p>
      </div>
    </div>

    {/* Phone Card */}
    <div className="flex flex-col sm:flex-row items-start p-6 bg-gray-100 rounded-lg shadow-md hover:shadow-xl transition-all duration-300">
      <FaPhone className="h-14 w-14 text-[#13689b]" />
      <div className="ml-0 sm:ml-6 text-left mt-4 sm:mt-0">
        <h4 className="text-xl font-semibold text-[#13689b]">Phone</h4>
        <p className="text-gray-600 text-sm">+92 315 5333 209</p>
        <p className="text-gray-600 text-sm">+92 321 0523 339</p>
      </div>
    </div>

    {/* Address Card */}
    <div className="flex flex-col sm:flex-row items-start p-6 bg-gray-100 rounded-lg shadow-md hover:shadow-xl transition-all duration-300">
      <FaMapMarkedAlt className="h-14 w-14 text-[#13689b]" />
      <div className="ml-0 sm:ml-6 text-left mt-4 sm:mt-0">
        <h4 className="text-xl font-semibold text-[#13689b]">Address</h4>
        <p className="text-gray-600 text-sm">Shop 1-B-3, Plot No. B-38, Street 27, Sector-F, Phase-I DHA Rawalpindi</p>
      </div>
    </div>
  </div>
</div>


      </div>
    </div>
  );
};

export default ContactPage;
